var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNumericSortDesc = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_812_52345)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.10597 15.9905C4.14079 15.9968 4.17666 16 4.21328 16C4.37681 16 4.52512 15.9345 4.63338 15.8283C4.63491 15.8268 4.63643 15.8253 4.63794 15.8238L7.43799 13.0239C7.67236 12.7894 7.67236 12.4094 7.43799 12.175C7.20361 11.9407 6.82349 11.9407 6.58911 12.175L4.81328 13.9509V0.6C4.81328 0.268799 4.54448 0 4.21328 0C3.88208 0 3.61328 0.268799 3.61328 0.6V13.9512L1.83716 12.175C1.60278 11.9407 1.2228 11.9407 0.988281 12.175C0.753906 12.4094 0.753906 12.7894 0.988281 13.0239L3.78833 15.8238C3.87801 15.9142 3.98947 15.9696 4.10597 15.9905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8149 6.40005H11.8148C11.4836 6.40005 11.2148 6.13125 11.2148 5.80005C11.2148 5.46885 11.4836 5.20005 11.8148 5.20005H13.8149C13.9252 5.20005 14.0149 5.1104 14.0149 4.99995V4.00005H12.6149C11.8428 4.00005 11.2148 3.37207 11.2148 2.59995V1.39995C11.2148 0.627979 11.8428 0 12.6149 0H13.8149C14.5869 0 15.2149 0.627979 15.2149 1.39995V4.99995C15.2149 5.77207 14.5869 6.40005 13.8149 6.40005ZM12.6149 1.2C12.5045 1.2 12.4148 1.28965 12.4148 1.39995V2.59995C12.4148 2.7104 12.5045 2.80005 12.6149 2.80005H14.0149V1.39995C14.0149 1.28965 13.9252 1.2 13.8149 1.2H12.6149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.204 15.8001C13.2077 15.8002 13.2113 15.8002 13.2149 15.8002C13.2186 15.8002 13.2222 15.8002 13.2258 15.8001H14.6149C14.9461 15.8001 15.2149 15.5313 15.2149 15.2001C15.2149 14.8689 14.9461 14.6001 14.6149 14.6001H13.8149V10.0001C13.8149 9.66895 13.5461 9.40015 13.2149 9.40015H11.8148C11.4836 9.40015 11.2148 9.66895 11.2148 10.0001C11.2148 10.3313 11.4836 10.6001 11.8148 10.6001H12.6149V14.6001H11.8148C11.4836 14.6001 11.2148 14.8689 11.2148 15.2001C11.2148 15.5313 11.4836 15.8001 11.8148 15.8001H13.204Z",
    fill: "white",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_812_52345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNumericSortDesc, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/numeric-sort-desc.47875022.svg";
export { ForwardRef as ReactComponent };